<template>
	<div
		class="modal fade keywordAdd"
		id="addKeywords"
		tabindex="-1"
		role="dialog"
		aria-labelledby="addEditCampaignGroup"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content campaign-addedit">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">Add Keywords</h5>
					<button
						type="button"
						class="close"
						@click="resetAllValues();resetFile()"
						data-dismiss="modal"
						aria-label="Close"
					>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<!-- <h2 class="text-center">Editing Campaign Group</h2> -->
					<div
						v-if="showKeywordForm"
						class="form-container"
						style="max-width: 800px;padding: 20px;margin-bottom: 15px;"
					>
						<!-- form start-->
						<form>
							<div class="row">
								<div class="col">
									<div class="form-group">
										<label>
											<input type="checkbox" v-on:click="hideShowMsg" v-model="isBoard"> Broad
										</label>
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text" id="basic-addon1">$</span>
											</div>
											<input
												type="number"
												v-model="boardBidAmount"
												placeholder="Bid Amount"
												class="form-control"
												:class="{ 'is-invalid': submitted && !checkBoardAmount }"
											>
											<span
												v-if="submitted && !checkBoardAmount"
												class="invalid-feedback"
											>Enter bid amount to proceed</span>
										</div>
									</div>
								</div>
								<div class="col">
									<div class="form-group">
										<label>
											<input type="checkbox" v-on:click="hideShowMsg" v-model="isPhrase"> Phrase
										</label>
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text" id="basic-addon1">$</span>
											</div>
											<input
												type="number"
												v-model="phraseBidAmount"
												placeholder="Bid Amount"
												class="form-control"
												:class="{ 'is-invalid': submitted && !checkPhraseAmount }"
											>
											<span
												v-if="submitted && !checkPhraseAmount"
												class="invalid-feedback"
											>Enter bid amount to proceed</span>
										</div>
									</div>
								</div>
								<div class="col">
									<div class="form-group">
										<label>
											<input type="checkbox" v-on:click="hideShowMsg" v-model="isExact"> Exact
										</label>
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text" id="basic-addon1">$</span>
											</div>
											<input
												type="number"
												v-model="exactBidAmount"
												placeholder="Bid Amount"
												class="form-control"
												:class="{ 'is-invalid': submitted && !checkExactAmount }"
											>
											<span
												v-if="submitted && !checkExactAmount"
												class="invalid-feedback"
											>Enter bid amount to proceed</span>
										</div>
									</div>
								</div>
							</div>
							<div
								class="form-group row"
								style="padding-top:30px;padding-bottom:0px"
								:style="!showAddGroup?'padding-bottom:5px':''"
							>
								<label class="col-md-4" style="padding-top:6px">Select AD Group</label>
								<multiselect
									v-model="keywordGrp"
									:options="keywordGrpList"
									:searchable="true"
									:loading = "loadingAddGroup"
									ref="multiselect"
									label="title"
									track-by="title"
									@tag="addKeywordGroup"
									open-direction="bottom"
									:taggable="true"
									placeholder="Search..."
									class="form-control multi-dropdown col-md-4"
									selectLabel = "Add Group"
									deselectLabel = "Remove Group"
									style="margin-left:15px;max-height:40px"
									:multiple="true"
									@input="resetKeywordGrp"
								>
									<template slot="noResult">
										<div>Oops! No Element Found</div>
									</template>
									<template slot="option" slot-scope="props" >
								      <div v-bind:class = "props.option.ams_ad_group_id ?  'option__desc' : ''"><span class="option__title">{{ props.option.title }}</span></div>
								    </template>
								</multiselect>
								<!-- <div v-if="showAddNewLoader" class="spinner-border" ></div>
										<button v-if="!showAddNewLoader && keywordGrp && !keywordGrp.ams_ad_group_id" class="btn btn-primary add-new-group" @click = "saveNewKeyWordGroup">
												<i class="fa fa-plus"></i> Save
								</button>-->
								<div class="col-md-12" v-if="Object.keys(keywordGrp).length">
									<span
										style="color:red;padding-top:2px; font-size:13px"
									>{{'(You can add upto '+ getAddedKeywordCount() +' keywords in this group.)'}}</span>
								</div>
							</div>
							<!-- <div class="form-group row">
								<label>Group Bid</label>
								<input type="text" v-model="groupBid" class="form-control"
								 :class="{ 'is-invalid': submitted && !checkBoardAmount }
								  id="groupBid">
							</div>-->
							<div class="form-group row" v-if="keywordGrp && !keywordGrp.ams_ad_group_id" style="padding-bottom:30px">
								<label for="groupBid" class="col-sm-4 col-form-label">Group Bid</label>
								<div class="col-md-4" style="padding:0px;margin-left:15px">
									<input type="text" placeholder="Enter group bid" v-model="groupBid" class="form-control" id="groupBid">
									<div class="col-md-12 no-data-style" v-if="submitted && !groupBid && keywordGrp && !keywordGrp.ams_ad_group_id" >
										<p>Group bid is required</p>
									</div>
								</div>

							</div>
							<div class="keyword_add_type">
								<ul class="nav nav-tabs">
									<li>
										<a
											class="nav-link"
											@click="setTab('importFromCsv')"
											:class="currentTab == 'importFromCsv' ? 'active' : ''"
										>Import Keyword From CSV</a>
									</li>
									<li>
										<a
											class="nav-link"
											@click="setTab('addManually')"
											:class="currentTab == 'addManually' ? 'active' : ''"
										>Add Keyword Manually</a>
									</li>
								</ul>
							</div>
							<div v-if="currentTab == 'importFromCsv'" style="margin-top:30px" class="file_button">
								<a href="sampleCSV.csv" id="file_download_link" download>Download Sample Keyword CSV</a>
								<br>
								<div class="form-group row" style="margin-top:15px;margin-left:0px ">
									<input
										type="checkbox"
										name="firstHeader"
										v-model="headerChecked"
										:disabled="true"
										style="margin-top:10px"
									>
									<label style="margin-top:4px">First Header</label>
									<div
										v-show="fileUploading"
										class="spinner-border"
										style="display:block;margin:-5px 0px 0px 50px;"
									></div>

									<label v-if="!fileUploading && !nameOfFileUploaded" style="margin-left:8px">
										<input
											class="choose"
											type="file"
											placeholder="Import Keyword From csv"
											multiple="false"
											accept=".csv"
											@change="addKeywordFromCSV"
										>
									</label>
									<br>

									<div v-show="!fileUploading && nameOfFileUploaded">
										<label style="margin-left:20px;margin-top:4px">
											{{nameOfFileUploaded}}
											<i
												style="margin-left:20px"
												class="fa fa-times"
												@click="resetFile()"
											></i>
										</label>
									</div>
								</div>
								<span
									v-if="Object.keys(keywordGrp).length"
									style="color:grey;padding-top:20px"
								>{{'Only first '+ getAddedKeywordCount() +' keywords will be added.'}}</span>
								<br>
								<span
									class = "no-data-style"
									v-if="showNoFileMsg && submitted && !nameOfFileUploaded"
									style=""
								>Select a file to submit</span>
							</div>

							<div v-if="currentTab == 'addManually'" style="margin-top:30px">
								<label>Keywords</label>
								<br>
								<textarea
									v-model="keywordArray"
									class="form-control col-md-6"
									style="height:75px;width:65%;float:left;"
									v-on:click="hideMsgKeyword"
								></textarea>
							</div>
							<div v-if="currentTab=='addManually'">
								<br>
								<br>
								<br>
							</div>
							<!-- <button
									type="button"
									class="btn btn-primary"
									@click="saveKeywordToCampaign()"
									style="margin-left: 15px !important;margin-top: 25px !important;"
							>Add Keywords</button>-->

							<div class="col-md-12" style="color : red">
								<p></p>
							</div>
							<div class="col-md-12 no-data-style" v-if="showMsg" >
								<p>Select the bid type to proceed</p>
							</div>
							<div v-if="showMsgKeyword && currentTab=='addManually'"  class = "no-data-style">
								<span>Enter keyword to save</span>
							</div>
							<div v-if="noKeywordCampGrp"  class = "no-data-style">
								<span>Select keyword group</span>
							</div>
							<div v-if="showEmptyKeywordFromImport" class = "no-data-style">
								<p>No keyword to import</p>
							</div>
						</form>

						<!-- form end-->
					</div>

					<div
						v-if="!showKeywordForm"
						class="spinner-border"
						style="margin:auto;display:block;margin-top:60px"
					></div>
				</div>
				<div class="modal-footer"  style = "display: flex;justify-content: center">
					<!-- <button
						type="button"
						class="btn btn-secondary"
						data-dismiss="modal"
						@click="resetAllValues()"
					>Cancel</button>-->
					<button type="button" class="btn btn-primary" v-on:click="saveKeywordToCampaign()">Save</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	import CampaignDetailGridNew from "@/components/keyword/CampaignDetailGridNew";
	import XLSX from "xlsx";

	//import CampaignDetailFooterNew from '@/components/keyword/CampaignDetailFooterNew'
	export default {
		name: "AddCampaignKeywordNewModal",
		data() {
			return {
				groupBid: "",
				showNoFileMsg: false,
				keywordGrp: "",
				keywordGrpList: [],
				keywordAdditiontype: "addManually",
				isBoard: false,
				isPhrase: false,
				isExact: false,
				boardBidAmount: "",
				phraseBidAmount: "",
				exactBidAmount: "",
				keywordArray: "",
				submitted: false,
				importKeyword: false,
				importKeywordSpinner: true,
				importedKeywordList: [],
				showMsg: false,
				showMsgKeyword: false,
				showKeywordForm: true,
				keywordList: [],
				showEmptyKeywordFromImport: false,
				keywordCSVList: [],
				presighnedUrl: "",
				downloadUrl: "",
				currentTab: "addManually",
				headerChecked: true,
				fileUploading: false,
				nameOfFileUploaded: "",
				addKeywordGrp: "",
				showAddGroup: false,
				noKeywordCampGrp: false,
				loadingAddGroup: false
			};
		},
		components: {
			CampaignDetailGridNew,
			Multiselect
			//	CampaignDetailFooterNew
		},
		props: {
			selectedKeyword: {
				type: Object
			},
			vendorId: {
				type: String
			},
			campaignId: {
				type: String
			},
			brandId: {
				type: String
			},
			productList: {
				type: Array
			},
			productIdList: {
				type: Array
			},
			allKeywordsList: {
				type: Array
			},
			amsCampaignId: {
				type: String
			},
			sponseredType:{
				type: String
			}
		},
		mounted() {
			this.keywordList = this.allKeywordsList;
			this.getKeywordGroupList();
			$('#keywordGrp').attr("autocomplete","off")
		},
		computed: {
			checkBoardAmount() {
				//this.showMsg = false;
				//this.showMsgKeyword = false;
				let demical = /^\d+(,\d{3})*(\.\d{1,2})?$/;
				if (this.isBoard) {
					if (this.boardBidAmount.match(demical)) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			},
			checkPhraseAmount() {
				// this.showMsg = false;
				// this.showMsgKeyword = false;
				let demical = /^\d+(,\d{3})*(\.\d{1,2})?$/;
				if (this.isPhrase) {
					if (this.isPhrase && this.phraseBidAmount.match(demical)) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			},
			checkExactAmount() {
				// this.showMsg = false;
				// this.showMsgKeyword = false;
				let demical = /^\d+(,\d{3})*(\.\d{1,2})?$/;
				if (this.isExact) {
					if (this.isExact && this.exactBidAmount.match(demical)) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			}
		},
		watch: {
			keywordGrp() {
				if (this.keywordGrp.title) {
					this.noKeywordCampGrp = false;
				}
				this.groupBid = ''
			},
			selectedKeyword() {
				//this.showMsgKeyword = false;
				if (this.selectedKeyword) {
					let vm = this;
					if (this.selectedKeyword.keyword) {
						this.keywordArray = this.selectedKeyword.keyword.join("\n");
					}
					if (this.selectedKeyword.bids) {
						this.selectedKeyword.bids.forEach(element => {
							if (element.type.toLowerCase() == "broad") {
								vm.isBoard = true;
								vm.boardBidAmount = element.bid + "";
							} else if (element.type.toLowerCase() == "phrase") {
								vm.isPhrase = true;
								vm.phraseBidAmount = element.bid + "";
							} else if (element.type.toLowerCase() == "exact") {
								vm.isExact = true;
								vm.exactBidAmount = element.bid + "";
							}
						});
					}
				}
			},
			importKeyword() {
				let vm = this;
				this.showMsgKeyword = false;
				this.keywordArray = "";
				if (this.importKeyword) {
					var payload = { id: this.productIdList };
					vm.$store
						.dispatch("campaign/importKeywordFromProduct", payload)
						.then(res => {
							// let response = res.keywordjson.keyword
							if (JSON.parse(res[0].keywordjson) == null) {
								this.showEmptyKeywordFromImport = true;
								this.importKeyword = false;
							} else {
								for (var i = 0; i < res.length; i++) {
									for (
										var j = 0;
										j < JSON.parse(res[i].keywordjson).length;
										j++
									) {
										for (
											var k = 0;
											k <
											JSON.parse(res[i].keywordjson)[j]
												.keyword.length;
											k++
										) {
											if (
												i == res.length - 1 &&
												j ==
													JSON.parse(res[i].keywordjson)
														.length -
														1 &&
												k ==
													JSON.parse(res[i].keywordjson)[
														j
													].keyword.length -
														1
											) {
												vm.keywordArray =
													vm.keywordArray +
													JSON.parse(res[i].keywordjson)[
														j
													].keyword[k];
											} else {
												vm.keywordArray =
													vm.keywordArray +
													JSON.parse(res[i].keywordjson)[
														j
													].keyword[k] +
													"\n";
											}
										}
									}
								}
							}
							vm.importKeywordSpinner = false;
						});
				} else {
					this.keywordArray = "";
					this.importKeywordSpinner = true;
				}
			}
		},

		methods: {
			resetKeywordGrp(option) {
				if (option.length) {
					this.keywordGrp = option[option.length - 1];
				} else {
					this.keywordGrp = "";
				}
			},
			searchFromDb(searchText) {

				if(searchText!=""){
					let payload = {
						type:this.sponseredType,
						ams_campaign_id: this.amsCampaignId,
						q: searchText.toLowerCase()
					};
					this.loadingAddGroup = true;

					this.$store
						.dispatch("campaign/getKeywordGroupList", payload)
						.then(res => {
							this.loadingAddGroup = false;
							this.keywordGrpList = res;

						});
				}

			},
			addKeywordGroup(name) {
				this.keywordGrp = "";
				var pay = { title: name };
				this.keywordGrpList.push(pay);
				this.keywordGrp = pay;
			},
			getAddedKeywordCount() {
				let count = (this.keywordGrp && this.keywordGrp.count ? this.keywordGrp.count : 0);
				if (count) {
					return 1000 - count;
				} else {
					return 1000;
				}
			},
			getKeywordGroupList() {
				let payload = {
					type: this.sponseredType,
					ams_campaign_id: this.amsCampaignId
				};
				this.$store
					.dispatch("campaign/getKeywordGroupList", payload)
					.then(res => {
						this.keywordGrpList = res;
					});
			},
			// saveNewKeyWordGroup(){
			// 	//this.showAddNewLoader = true;
			// 	let vm = this;
			// 	let payload = {
			// 		ams_campaign_id: this.amsCampaignId,
			// 		local_campaign_id: this.campaignId,
			// 		title:this.keywordGrp.title,
			// 	}
			// 	this.keywordGrpList.forEach((item,index)=>{
			// 		if(item.title == this.keywordGrp.title){
			// 			keywordGrpList.splice(index,1);
			// 			return;
			// 		}
			// 	})
			// 	this.$store.dispatch('campaign/saveNewKeyWordGroup', payload).then((res) => {
			// 		//vm.showAddNewLoader = false;
			// 		vm.keywordGrpList.push(res);
			// 		vm.keywordGrp = res;
			// 		vm.showAddGroup = false;
			// 	})
			// },
			resetFile() {
				(this.nameOfFileUploaded = ""),
					(this.fileUploading = false),
					(this.presighnedUrl = ""),
					(this.downloadUrl = "");
				this.showNoFileMsg = false;
			},
			hideMsgKeyword() {
				this.showMsgKeyword = false;
				this.showEmptyKeywordFromImport = false;
			},
			hideShowMsg() {
				this.showMsg = false;
			},
			setTab(data) {
				this.currentTab = data;
			},
			addKeywordFromCSV(evt) {
				let file = evt.target.file || evt.target.files[0];
				let payload = {
					fileName: file.name,
					fileType: "text/x-csv"
				};
				let vm = this;
				let fileData = "";

				//	 var reader = new FileReader();
				//	 reader.readAsBinaryString(file);
				//	 reader.onload = function() {
				//	console.log(btoa(reader.result));
				this.fileUploading = true;
				vm.$store.dispatch("campaign/getPresighnedURL").then(res => {
					vm.presighnedUrl = res.uploadUrl;
					vm.downloadUrl = res.downloadUrl;
					let data = {
						url: res.uploadUrl,
						data: file
					};
					vm.$store
						.dispatch("campaign/uploadFile", data)
						.then(response => {
							console.log(response);
							vm.nameOfFileUploaded = file.name;
							vm.fileUploading = false;
							//alert("file uploaded")
						});
				});
				// };

				// reader.onload = function(e) {
				//     var data = new Uint8Array(e.target.result);
				//     var workbook = XLSX.read(data, {type: 'array'});
				// 	for (let [key, value] of Object.entries(workbook.Sheets.Sheet1)) {
				// 		vm.keywordCSVList.push(value.v)
				// 	}
				// 	console.log(vm.keywordCSVList);
				// //	vm.keywordArray.split('\n')
				//     let listStr = vm.keywordCSVList.join('\n');
				// 	vm.keywordArray = listStr.concat(vm.keywordArray)
				//
				//   };
				// reader.readAsArrayBuffer(file);
				//event.addEventListener('change', this.addKeywordFromCSV, false);
			},
			saveKeywordToCampaign() {
				this.submitted = true;
				let bids = [];
				if (this.isBoard) {
					this.showMsg = false;
					if (this.checkBoardAmount) {
						let board = {
							bid: parseFloat(this.boardBidAmount),
							type: "Broad"
						};
						bids.push(board);
					} else {
						return;
					}
				}
				if (this.isPhrase) {
					this.showMsg = false;
					if (this.checkPhraseAmount) {
						let phrase = {
							bid: parseFloat(this.phraseBidAmount),
							type: "Phrase"
						};
						bids.push(phrase);
					} else {
						return;
					}
				}
				if (this.isExact) {
					this.showMsg = false;
					if (this.checkExactAmount) {
						let exact = {
							bid: parseFloat(this.exactBidAmount),
							type: "Exact"
						};
						bids.push(exact);
					} else {
						return;
					}
				}

				if (!(this.keywordGrp && this.keywordGrp.title)) {
					this.noKeywordCampGrp = true;
					return;
				}
				if (!this.groupBid && !this.keywordGrp.ams_ad_group_id) {
					return;
				}
				if (
					(this.isBoard && this.checkBoardAmount) ||
					(this.isPhrase && this.checkPhraseAmount) ||
					(this.isExact && this.checkExactAmount)
				) {
					if (this.currentTab == "importFromCsv") {
						this.addFileValidation();
					} else {
						this.addManualValidation(bids);
					}
				} else {
					this.showMsg = true;
				}
			},
			addManualValidation(bids) {
				if (
					(this.newKeywordObject && this.newKeywordObject.length) ||
					this.keywordArray.length
				) {
					this.keywordArray.split("\n").forEach((row, index) => {
						if (row.trim()) {
							bids.forEach(bidRow => {
								let tempObj = {};
								tempObj["keyword_text"] = row;
								tempObj["match_type"] = bidRow.type;
								tempObj["bid"] = bidRow.bid;
								tempObj["state"] = "enabled";
								this.keywordList.push(tempObj);
							});
						}
					});
					this.closeModal();
					//this.saveKeywordOnServer();
				} else {
					this.showMsgKeyword = true;
				}
			},
			addFileValidation() {
				if (this.downloadUrl && this.presighnedUrl) {
					this.closeModal();
				} else {
					this.showNoFileMsg = true;
				}
			},
			closeModal() {
				if (this.currentTab == "importFromCsv") {
					let payload = {
						phrase: this.isPhrase,
						exact: this.isExact,
						broad: this.isBoard,
						phrase_bid: parseFloat(this.phraseBidAmount),
						exact_bid: parseFloat(this.exactBidAmount),
						broad_bid: this.boardBidAmount
							? parseFloat(this.boardBidAmount)
							: null,
						keywordAdditiontype: this.currentTab,
						fileUrl: this.presighnedUrl,
						downloadUrl: this.downloadUrl
					};
					this.$emit("isFileOrManual", payload);
				}
				else{
					let payload = {
						phrase: false,
						exact: false,
						broad:false,
						keywordAdditiontype: "",
						fileUrl: "",
						downloadUrl: ""
					}
						this.$emit("isFileOrManual", payload);
				}
				this.$emit(
					"saveKeywordToCampaign",
					this.keywordList,
					this.keywordGrp,
					this.keywordGrp.ams_ad_group_id ? this.keywordGrp.bid :this.groupBid,
					this.keywordGrp.ams_ad_group_id
				);
				this.resetAllValues();
				this.resetFile();
				$("#addKeywords").modal("hide");
			},
			// saveKeywordOnServer() {
			// 	let payloadObject = {
			// 		keywords: this.keywordArray.split("\n"),
			// 		amsProfileId: this.brandId,
			// 		goVendorCd: this.vendorId,
			// 		phrase: this.isPhrase,
			// 		exact: this.isExact,
			// 		broad: this.isBoard,
			// 		phrase_bid: parseFloat(this.phraseBidAmount),
			// 		exact_bid: parseFloat(this.exactBidAmount),
			// 		broad_bid: this.boardBidAmount
			// 			? parseFloat(this.boardBidAmount)
			// 			: null,
			// 		campaignId: this.campaignId,
			// 		userName: JSON.parse(sessionStorage.getItem("session")).name
			// 	};
			// 	this.showKeywordForm = false;
			// 	this.$store
			// 		.dispatch("keyword/saveKeywordForCampaign", payloadObject)
			// 		.then(() => {
			// 			this.showKeywordForm = true;
			// 			this.$emit("keywordAdded", true);
			// 			this.resetAllValues();
			// 		});
			// },
			resetAllValues() {
				this.$emit("resetSelectedItem");
				this.isBoard = false;
				this.isPhrase = false;
				this.isExact = false;
				this.phraseBidAmount = "";
				this.exactBidAmount = "";
				this.boardBidAmount = "";
				this.keywordArray = "";
				this.submitted = false;
				this.importKeyword = false;
				this.importKeywordSpinner = true;
				this.showMsgKeyword = false;
				this.showMsg = false;
				this.showEmptyKeywordFromImport = false;
				this.keywordGrp = "";
				this.showNoFileMsg = false;
				this.noKeywordCampGrp = false;
				this.keywordGrpList = [];
				this.groupBid = "";
				this.currentTab = "";
				this.presighnedUrl = "";
				this.downloadUrl = "";
				this.currentTab = "addManually";
				this.headerChecked = true;
				this.fileUploading = false;
				this.nameOfFileUploaded = "";
				this.addKeywordGrp = "";
				this.showAddGroup = false;
				this.noKeywordCampGrp = false;
				this.keywordList = [];
			},
			fetchKeywordList(ams_campaign_id, campaignId) {
				// let vm = this;
				// let data = {
				// 	ams_campaign_id: null,
				// 	campaignId : parseInt(this.campaignId)
				// }
				// this.showKeywordForm = false;
				// this.$store.dispatch("keyword/getKeywordList", data).then((resp)=>{
				// 	this.showKeywordForm = true;
				// 	this.keywordList = resp.data.entities;
				// })
			}
		}
	};
</script>

<style lang="scss">
.keyword_add_type .nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
	background: #3da3a7 !important;
	color: white !important;
	font-weight: 550 !important;
	/* font-size: 18px; */
}
.choose::-webkit-file-upload-button {
	color: white;
	display: inline-block;
	background: $tert-blue;
	border: none;
	padding: 7px 15px;
	font-weight: 700;
	border-radius: 3px;
	white-space: nowrap;
	cursor: pointer;
	font-size: 10pt;
}
.add-new-group.btn-primary {
	margin: 6px !important;
	padding: 0 10px;
	font-size: 14px;
	height: 30px;
	margin-right: auto !important;
	margin-left: 15px !important;
}
/* .multiselect__option .multiselect__option--selected{
	background-color: red !important;
}
.multiselect__option--highlight{
	background-color: red !important;

} */
.option__desc{
	color: black;
}
.option_noID{
	color: red;
}
span.multiselect__option.multiselect__option--highlight.multiselect__option--selected .option_noID {
    color:white !important
}

span.multiselect__option.multiselect__option--highlight.multiselect__option--selected .option__desc {
    color:white !important
}
span.multiselect__option {
	&.multiselect__option--highlight {
		background: $primary-green;
	}
}
/* .keywordAdd .multiselect__option{
	padding: 0px !important
} */
/* .btn-file input[type=file] {
	  position: absolute;
	  top: 0;
	  right: 0;
	  min-width: 100%;
	  min-height: 100%;
	  font-size: 100px;
	  text-align: right;
	  filter: alpha(opacity=0);
	  opacity: 0;
	  outline: none;
	  background: white;
	  cursor: inherit;
	  display: block;
	}
	.btn-file {
	  position: relative;
	  overflow: hidden;
} */
</style>
